import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Product } from '../types';
import { useI18n } from '../hooks/useI18n';

interface LowStockModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    lowStockItems: { product: Product; requested: number }[];
}

const LowStockModal: React.FC<LowStockModalProps> = ({ isOpen, onClose, onConfirm, lowStockItems }) => {
    const { t, isRTL } = useI18n();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
            <div className={`bg-white rounded-lg p-6 w-full max-w-lg shadow-xl ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
                <div className="flex items-center gap-3 mb-4 text-yellow-600">
                    <AlertTriangle size={32} />
                    <h2 className="text-2xl font-bold">{t('stock.orders.lowStockWarning')}</h2>
                </div>

                <p className="text-gray-600 mb-4">
                    {t('stock.orders.lowStockMessage')}
                </p>

                <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-6">
                    <ul className="space-y-2">
                        {lowStockItems.map(({ product, requested }, index) => (
                            <li key={index} className="flex justify-between text-sm">
                                <span className="font-medium text-gray-800">{product.name} ({product.code})</span>
                                <span className="text-yellow-800">
                                    {t('stock.products.availableQuantity')}: {product.quantityOnHand - product.reservedQuantity} |{' '}
                                    {t('stock.orders.requested')}: {requested}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={`flex justify-end gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
                    <button
                        onClick={onClose}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    >
                        {t('common.cancel')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 font-bold"
                    >
                        {t('stock.orders.continueAnyway')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LowStockModal;
